import script from "./StatNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./StatNumber.vue?vue&type=script&setup=true&lang=js"

import "./StatNumber.vue?vue&type=style&index=0&id=158cccda&scoped=true&lang=scss"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-158cccda"]])

export default __exports__